import { createContext, Dispatch, useState, ReactNode } from 'react'
import { userProfileType } from '../auth.types'

type UserProfileProviderProps = {
    children: ReactNode
}

export const userProfileInitialState: userProfileType = {
    user: {
        first_name: '',
        is_activated: false,
        last_name: '',
        state: 0,
        status: '',
        token: '',
        user_id: '',
        organizations: [],
        roles: [],
        email: '',
        rbac2_roles: [],
        require_mfa: false,
    },
}

export type UserProfileContextType = {
    userProfile: userProfileType
    setUserProfile: Dispatch<React.SetStateAction<userProfileType>>
}

export const UserProfileContext = createContext<UserProfileContextType>({
    userProfile: userProfileInitialState,
    setUserProfile: () => {},
})

export const UserProfileProvider = ({ children }: UserProfileProviderProps) => {
    const [userProfile, setUserProfile] = useState(userProfileInitialState)

    return (
        <UserProfileContext.Provider value={{ userProfile, setUserProfile }}>
            {children}
        </UserProfileContext.Provider>
    )
}
